import { Status } from './move-icon.types';

export const MOVE_BUTTON_STYLES = {
  [Status.Active]: {
    border: 'linear-gradient(180deg, #FFFFFF 0%, #4FB5FF 100%)',
    background: 'linear-gradient(180deg, rgba(13, 20, 80, 1) 0%, rgba(23, 33, 120, 1) 100%)',
    bottomBorder: '#4FB5FF',
    bottomBackground:
      'linear-gradient(-67.96deg, rgba(40, 35, 120, 1) 0%, rgba(12, 9, 61, 1) 100%)',
  },
  [Status.Selected]: {
    border: 'linear-gradient(180deg, #FFFFFF 0%, #FFA700 100%)',
    background: 'linear-gradient(180deg, #0D1450 0%, #FFC000 158.75%)',
    bottomBorder: '#FFA700',
    bottomBackground: 'linear-gradient(292deg, #FF8B00 14.41%, #FFC000 85.59%)',
  },
  [Status.Disabled]: {
    border: 'linear-gradient(180deg, #322E66 0%, #373470 100%)',
    background: 'linear-gradient(180deg, rgba(21, 23, 40, 1) 0%,rgba(29, 33, 62, 1) 100%)',
    bottomBorder: '#373470',
    bottomBackground: 'linear-gradient(292deg, #373470 14.41%, #1C1A42 85.59%)',
  },
};
